const create = (api) => {

    const getSystemNotificationsList = (orgId='', lang='en-US', pageNum=1, pageSize=10, sort='timestamp', directionSort='1') =>{
        return api.get(`/systemnotifications/list?organizationId=${orgId}&language=${lang}&pageNumber=${pageNum}&pageSize=${pageSize}&sort=${sort}&directionSort=${directionSort}`);
    }
  // This method is used to post to system notification attested database.
    const postSystemNotifications = (notificationData) => {
        return api.post(`/systemnotifications`, notificationData);
    }    

    const putSystemNotifications = (notificationId, enable) => {
        return api.put(`/systemnotifications/${notificationId}?enable=${enable}`);
    }

    return {
        getSystemNotificationsList,
        postSystemNotifications,
        putSystemNotifications     
    }
}

export default {
    create
}